import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './img/loding.gif'


const _withScopeId = n => (_pushScopeId("data-v-7aeaf732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sv-paging-count" }
const _hoisted_2 = {
  key: 0,
  class: "sv-paging-load-img",
  src: _imports_0
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Per Page", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sv-paging-load-img",
  src: _imports_0
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  style: {"color":"#333"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Jump to", -1))
const _hoisted_10 = { style: {"vertical-align":"top"} }
const _hoisted_11 = ["max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "sv-paging",
    style: _normalizeStyle({ 'text-align': _ctx.modelValue.align || 'right' })
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(" Count: "),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.modelValue.itemCount), 1))
    ]),
    _hoisted_4,
    (_ctx.showPerPage)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: _ctx.modelValue.perPage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.perPage) = $event)),
          "popper-class": "sv-page-select-popper",
          class: "sv-page-select",
          placement: "top",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPerPage(_ctx.modelValue))),
          placeholder: "Select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perPageList, (value) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: value,
                key: value,
                label: value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(value), 1)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToFirstPage && _ctx.goToFirstPage(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["sv-paging-icon", _ctx.modelValue.page === 1 ? 'sv-paging-icon-first-no' : 'sv-paging-icon-first'])
        }, null, 2)
      ]),
      _withDirectives(_createElementVNode("p", { class: "sv-paging-msg" }, _toDisplayString(_ctx.btnText.first), 513), [
        [_vShow, _ctx.showMsgType === 'first']
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToPrevPage && _ctx.goToPrevPage(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["sv-paging-icon", _ctx.modelValue.page < 2 ? 'sv-paging-icon-pre-no' : 'sv-paging-icon-pre'])
        }, null, 2)
      ]),
      _withDirectives(_createElementVNode("p", { class: "sv-paging-msg" }, _toDisplayString(_ctx.btnText.pre), 513), [
        [_vShow, _ctx.showMsgType === 'pre']
      ])
    ]),
    _createElementVNode("span", null, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.modelValue.page) + " / " + _toDisplayString(_ctx.modelValue.pageCount || 1), 1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["sv-paging-icon", _ctx.modelValue.page < _ctx.modelValue.pageCount ? 'sv-paging-icon-next' : 'sv-paging-icon-next-no'])
        }, null, 2)
      ]),
      _withDirectives(_createElementVNode("p", { class: "sv-paging-msg" }, _toDisplayString(_ctx.btnText.next), 513), [
        [_vShow, _ctx.showMsgType === 'next']
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToFinallyPage && _ctx.goToFinallyPage(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["sv-paging-icon", _ctx.modelValue.page <  _ctx.modelValue.pageCount ? 'sv-paging-icon-last' : 'sv-paging-icon-last-no'])
        }, null, 2)
      ]),
      _withDirectives(_createElementVNode("p", { class: "sv-paging-msg" }, _toDisplayString(_ctx.btnText.last), 513), [
        [_vShow, _ctx.showMsgType === 'last']
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageValue) = $event)),
        title: "",
        onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handlePageKeyDown && _ctx.handlePageKeyDown(...args))),
        onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handlePageInput && _ctx.handlePageInput(...args))),
        onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args)), ["enter"])),
        min: "1",
        max: _ctx.modelValue.pageCount
      }, null, 40, _hoisted_11), [
        [_vModelText, _ctx.pageValue]
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args)), ["prevent"])),
        class: "sv-paging-go"
      }, _toDisplayString(_ctx.btnText.gobtn), 1),
      _withDirectives(_createElementVNode("p", { class: "sv-paging-msg" }, _toDisplayString(_ctx.btnText.go), 513), [
        [_vShow, _ctx.showMsgType === 'goTo']
      ])
    ])
  ], 4))
}